var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 95,
    viewBox: "0 0 98 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2245",
    "data-name": "Group 2245",
    transform: "translate(-1270 -6971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_797",
    "data-name": "Rectangle 797",
    d: "M10,0H88A10,10,0,0,1,98,10V95a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    transform: "translate(1270 6971)",
    fill: "#05131a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-arrow-up",
    "data-name": "Icon feather-arrow-up",
    transform: "translate(1283.701 6983.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6304",
    "data-name": "Path 6304",
    d: "M18,63.1V7.5",
    transform: "translate(17.299 0)",
    fill: "none",
    stroke: "#2dbc9d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6305",
    "data-name": "Path 6305",
    d: "M7.5,35.3,35.3,7.5,63.1,35.3",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#2dbc9d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpButton);
export default __webpack_public_path__ + "static/media/up_button.50f85bb1a35cf10318e988bcff754e0f.svg";
export { ForwardRef as ReactComponent };